"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDialogContent = exports.FullScreenContainer = exports.CustomDialogActions = exports.StyledArrowLeft = exports.StyledIconButton = exports.StyledTypography = exports.StyledDefaultBackText = exports.StyledNoBackTextDivMobile = exports.StyledNoBackTextDiv = exports.Wrapper = exports.StyledBackButton = exports.StyledButton = void 0;
var IconButton_1 = __importDefault(require("../IconButton"));
var Typography_1 = __importDefault(require("../Typography"));
var colors_1 = require("../ThemeProvider/colors");
var material_1 = require("@mui/material");
var Button_1 = __importDefault(require("../Button"));
var prism_icons_1 = require("@octanner/prism-icons");
exports.StyledButton = (0, material_1.styled)(Button_1.default)({
    color: colors_1.tannerGray[700],
    '&:hover': {
        backgroundColor: colors_1.tannerGray[200],
    },
    '&:focus': {
        backgroundColor: colors_1.tannerGray[200],
    },
    '&.Mui-disabled': {
        color: colors_1.tannerGray[700],
    },
});
exports.StyledBackButton = (0, material_1.styled)(exports.StyledButton)({
    paddingLeft: 9,
    '&:focus': {
        textDecoration: 'underline',
    },
    '&:active': {
        textDecoration: 'none',
    },
});
exports.Wrapper = (0, material_1.styled)('div', {
    shouldForwardProp: function (prop) { return prop !== 'upperShadow' && prop !== 'isMobile'; },
})(function (_a) {
    var _b = _a.upperShadow, upperShadow = _b === void 0 ? false : _b, _c = _a.isMobile, isMobile = _c === void 0 ? false : _c;
    return ({
        display: 'flex',
        justifyContent: 'space-between',
        padding: isMobile ? '8px' : '16px 24px',
        boxShadow: upperShadow ? '0px 4px 4px rgba(0, 0, 0, 0.25)' : 'none',
    });
});
exports.StyledNoBackTextDiv = (0, material_1.styled)('div')({
    height: 40,
    width: 96,
});
exports.StyledNoBackTextDivMobile = (0, material_1.styled)('div')({
    height: 40,
    width: 40,
});
exports.StyledDefaultBackText = (0, material_1.styled)('div')({
    paddingTop: 1,
});
exports.StyledTypography = (0, material_1.styled)(Typography_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'hideTitle'; },
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding-top: 0;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  padding-top: 0;\n  ", "\n"])), function (_a) {
    var hideTitle = _a.hideTitle;
    return hideTitle &&
        "\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  ";
});
exports.StyledIconButton = (0, material_1.styled)(IconButton_1.default)({
    color: colors_1.tannerGray['700'],
    '&:focus': {
        ':focus-visible': {
            backgroundColor: colors_1.tannerGray['200'],
        },
    },
    '&:hover': {
        color: colors_1.tannerGray['700'],
        backgroundColor: colors_1.tannerGray['200'],
    },
});
exports.StyledArrowLeft = (0, material_1.styled)(prism_icons_1.ArrowLeft)({
    marginBottom: 1,
    marginRight: -4,
});
exports.CustomDialogActions = (0, material_1.styled)(material_1.DialogActions, {
    shouldForwardProp: function (prop) { return prop !== 'isMobile'; },
})(function (_a) {
    var isMobile = _a.isMobile;
    return (__assign({}, (isMobile && {
        padding: '8px',
    })));
});
exports.FullScreenContainer = (0, material_1.styled)('div')({
    maxWidth: '768px',
    margin: '10px auto',
    width: '100%',
});
exports.StyledDialogContent = (0, material_1.styled)(material_1.DialogContent, {
    shouldForwardProp: function (prop) { return prop !== 'hasNoActionsAndNav'; },
})(function (_a) {
    var hasNoActionsAndNav = _a.hasNoActionsAndNav;
    return (__assign({}, (hasNoActionsAndNav && {
        padding: '0',
    })));
});
var templateObject_1;
//# sourceMappingURL=styles.js.map